<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Import </span> /
      <span> Select Groups </span>
    </nav>
    <import-steps></import-steps>

    <div class="container">
      <div class="mx-2">
        <h2 class="flow-heading mt-5 mb-3">Select {{ crmName }} groups to import</h2>

        <div class="flow-tips">
          <div class="flow-subheading mb-3">Here is how it works:</div>
          <p class="flow-tips__item" v-for="tip in tips" :key="tip">
            <i class="fa fa-check flow-tips__icon" aria-hidden="true"></i> {{ tip }}
          </p>
        </div>

        <flow-search
          @input="search = $event"
          @toggle-all="onToggleAll"
          :search="search"
          placeholder="Search by group name"
          :everySelected="everySelected"
        ></flow-search>

        <form :action="`/import/confirm/${searchParams}`" method="POST" class="text-center">
          <div class="flow-groups-container">
            <flow-groups
              :groups="filteredGroups"
              :selectedGroupsIds="selectedGroupsIds"
              @toggle-item="onToggleGroup"
            ></flow-groups>
            <input type="hidden" name="selectedGroupsIds" :value="stringifyIds" />
          </div>

          <div>
            <a class="btn btn-lg btn-outline-primary mr-2" href="/import/select-method/">Back</a>
            <button type="submit" class="btn btn-lg btn-primary" :disabled="!selectedGroupsIds.length">Continue</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ImportSteps from '../components/import/ImportSteps';
import FlowGroups from '../components/shared/FlowGroups';
import FlowSearch from '../components/shared/FlowSearch';
import flowGroups from '../mixins/flowGroups.js';
import {getCommercialName} from '../utility/crms/getCommercialName.js';

export default {
  name: 'import-select-groups-page',
  mixins: [flowGroups],
  components: {
    ImportSteps,
    FlowGroups,
    FlowSearch,
  },
  props: {
    groups: {
      type: String,
      required: true,
    },
    crm: {
      type: String,
      required: true,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    tips() {
      return [
        `${this.crmName} groups will be added to ${this.platformTitle} as groups.`,
        `The new ${this.platformTitle} groups will retain the names of your ${this.crmName} groups (you can change them later if you please).`,
      ];
    },
    crmName() {
      return getCommercialName(JSON.parse(this.crm).crm_name);
    },
    searchParams() {
      return window.location.search;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';
.flow-tips {
  max-width: 700px;
  margin: 0 auto 16px;
  &__item {
    text-align: left;
    margin-bottom: 10px;
    display: flex;
    align-items: baseline;
    gap: 10px;
  }
  &__icon {
    font-size: 18px;
  }
}

.flow-groups-container {
  max-height: 272px;
  margin: 30px auto;
}
</style>
